import $ from 'jquery';
import constants from 'Constants.js';
import Immutable from 'immutable';

import { View } from 'backbone';

import _Template from 'properties/navigation/accessibility.ejs';

class AccessibilityView extends View {

    initialize( opts ) {
        this.options = opts || {};
        this.template = _Template;
        this.tagName = 'div';
        this.id = '#accessibilityProp';
        this.config = opts.config || {};

        return this;
    }

    render() {
        this.$el.empty();
        this.$el.css('display', '');
        if(this.template) { 
            this.$el.html(this.template(this.model.toJSON()));
        }

        if (this.config.sameAsCaption) {
            this.$el.find('#navSameAsCaption').removeClass('hide');
            this.$el.find('#propAccessSilent').addClass('hide');
        }

        setTimeout(()=>{
            const shownItems = Number(!$('#navSameAsCaption').hasClass('hide'))
                + $('#propAccessSilent').children().length
                + $('#propAccessDescription').children().length
                + $('#propAccessBackgroundPicture').children().length;

            if (shownItems === 0) {
                this.$el.css('display', 'none');
            }
        },100);

        return this;
    }

}

export default AccessibilityView;